<template>
    <div id="home">
        <Menu/>
        <Banner/>
        <AboutUs/>
        <Mission/>
        <Products/>
        <Benefits/>
        <Contact/>
    </div>
</template>

<script>
import Menu from '../components/Menu.vue'
import Banner from '../components/Banner.vue'
import AboutUs from '../components/AboutUs.vue'
import Mission from '../components/Mission.vue'
import Products from '../components/Products.vue'
import Benefits from '../components/Benefits.vue'
import Contact from '../components/Contact.vue'

export default {
name: 'Home',
components: {
    Menu,
    Banner,
    AboutUs,
    Mission,
    Products,
    Benefits,
    Contact
}
}
</script>

<style>
</style>
  